import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';
import { ItemType } from '../components/ExtremeGrid/entities';

export interface IBaseFields {
	projectId?: string;
	formId?: string;
	fieldName?: string;
	fieldType?: ItemType;
	fieldCaption?: string;
}

export interface IFields extends IBaseFields {}

export interface IReadonlyFields extends IBaseFields {}

export type Fields = ReadonlyRecord<IReadonlyFields>;

export const FieldsFactory = Record<IReadonlyFields>({
	fieldCaption: null,
	projectId: '',
	formId: '',
	fieldName: '',
	fieldType: ItemType.String
});

export const FieldsFactoryFromJS = function (data: IFields) {
	return FieldsFactory(data);
};
